import DOMPurify from 'dompurify';

const ALLOWED_DOMAINS = [
    '24rent.fi',
    // Walley iframe loader script + assets are served from these hosts.
    'walleydev.com',         // staging / UAT (e.g. api.uat.walleydev.com)
    'walleypay.com',         // production
    // Paytrail hosted payment page (used for non-Finnish customers).
    'paytrail.com',
    'pay.paytrail.com',
    // Paytrail's card tokenization ("pay and save card") flow redirects through
    // Payment Highway before returning to services.paytrail.com.
    'paymenthighway.io',
    'sph-test-solinor.com',
    'localhost',
];

/**
 * Validates that a redirect URL points to an allowed domain.
 * Returns the validated URL string, or a fallback if invalid.
 */
export function validateRedirectUrl(url: string, fallback: string = '/'): string {
    try {
        const parsed = new URL(url, window.location.origin);

        // Allow same-origin relative URLs
        if (parsed.origin === window.location.origin) {
            return url;
        }

        // Block javascript: and data: protocols
        if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
            return fallback;
        }

        // Check against allowed domains
        const isAllowed = ALLOWED_DOMAINS.some(domain =>
            parsed.hostname === domain || parsed.hostname.endsWith('.' + domain)
        );

        return isAllowed ? url : fallback;
    } catch {
        return fallback;
    }
}

/**
 * Sanitizes HTML content to prevent XSS attacks.
 */
export function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(html);
}
